import { styled } from '@mui/material';
import { Close, ChevronLeftOutlined } from '@next-common/material-ui-icons';
const iconStyle = {
    cursor: 'pointer',
    zIndex: 999,
    background: 'rgba(255, 255, 255, 0.4)',
    borderRadius: '16px 16px 0px 0px',
    width: '24px',
    height: '24px'
};
export const StyledCloseIcon = styled(Close)(Object.assign({}, iconStyle));
export const StyledChevronIcon = styled(ChevronLeftOutlined)(Object.assign({}, iconStyle));
export const StyledCloseIconNoTitle = styled(Close)(Object.assign({}, iconStyle));
export const StyledChevronIconNoTitle = styled(ChevronLeftOutlined)(Object.assign({}, iconStyle));
